import getPath from "@neonaut/lib-js/es/object/getPath";
/**
 * Gets the property value by key, falling back to the specified fallback if value is not defined.
 */
export default function getFeatureProperty(feature, key, fallback = null) {
    return getPath(feature, ["properties", key], fallback);
}
